type JsonObject = {
    [key: string]: any;
};

function deepFilterJsonArrays(
    data: JsonObject[],
    searchTerm: string,
): JsonObject[] {
    // Normalize search term to lowercase
    const normalizedSearch = searchTerm.toLowerCase();

    // Deep clone the original data to avoid mutation
    const filteredData = JSON.parse(JSON.stringify(data));

    function matchesSearch(value: any): boolean {
        // Check if the value is a string and contains the search term
        if (typeof value === 'string') {
            return value.toLowerCase().includes(normalizedSearch);
        }
        return false;
    }

    function recursiveFilter(obj: JsonObject): boolean {
        // Ignore fields we want to skip
        const ignoredFields = ['id', '__typename'];

        // Check if any field matches the search term
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(obj)) {
            // Skip ignored fields
            // eslint-disable-next-line no-continue
            if (ignoredFields.includes(key)) continue;

            // If the current value is a string and matches, keep the object
            if (matchesSearch(value)) return true;

            // If the value is an array, filter or check its contents
            if (Array.isArray(value)) {
                // Recursively filter the array
                // eslint-disable-next-line no-param-reassign
                obj[key] = value.filter(item =>
                    typeof item === 'object'
                        ? recursiveFilter(item)
                        : matchesSearch(item),
                );

                // If the filtered array is not empty, keep the object
                if (obj[key].length > 0) return true;
            }

            // If the value is an object, recursively check its contents
            if (value !== null && typeof value === 'object') {
                if (recursiveFilter(value)) return true;
            }
        }

        return false;
    }

    // Filter the top-level arrays
    return filteredData.filter(recursiveFilter);
}

// Example usage
function searchHierarchy(data: JsonObject[], searchTerm: string): JsonObject[] {
    return deepFilterJsonArrays(data, searchTerm);
}

// Export for potential use
export { searchHierarchy };
